// extracted by mini-css-extract-plugin
export default {"textBox":"Text_textBox__7W6FV"};